/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Ai_Tools_Studio_Step_PhotosInputs */

const en_directory_ai_tools_studio_step_photos = /** @type {(inputs: Directory_Ai_Tools_Studio_Step_PhotosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add two photos, one person each`)
};

const zh_directory_ai_tools_studio_step_photos = /** @type {(inputs: Directory_Ai_Tools_Studio_Step_PhotosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上传两张照片，每张一个人`)
};

/**
* | output |
* | --- |
* | "Add two photos, one person each" |
*
* @param {Directory_Ai_Tools_Studio_Step_PhotosInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ai_tools_studio_step_photos = /** @type {((inputs?: Directory_Ai_Tools_Studio_Step_PhotosInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ai_Tools_Studio_Step_PhotosInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ai_tools_studio_step_photos(inputs)
	return zh_directory_ai_tools_studio_step_photos(inputs)
});
export { directory_ai_tools_studio_step_photos as "directory.ai_tools.studio.step_photos" }